// src/firebase.js

// Firebase SDK
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';


// Configuración que te dio Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBVp_jPbbDldczjcXQlihzDDAXpK5WnIX4",
  authDomain: "ampi-riviera-system.firebaseapp.com",
  projectId: "ampi-riviera-system",
  storageBucket: "ampi-riviera-system.firebasestorage.app",
  messagingSenderId: "267537429479",
  appId: "1:267537429479:web:3a419ebb9db1dd334b8342",
  measurementId: "G-DMDCY2F0XP"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Servicios de Firebase que vas a usar
export const db = getFirestore(app);       // Firestore (base de datos)
export const auth = getAuth(app);          // Auth (para logins)
export const analytics = getAnalytics(app); // Métricas (opcional)
export const storage = getStorage(app);

// Segunda instancia de Auth para migraciones (no afecta sesión actual)
const secondaryApp = initializeApp(firebaseConfig, "Secondary");
export const secondaryAuth = getAuth(secondaryApp);
